module.exports = __webpack_public_path__ + "img/how-to-find-a-product-or-family.74b1270d.png";